// Safe wrappers for browser storage APIs.
// These must be SSR-safe: `window` is not available during server-side rendering.

export const hasLocalStorage = () =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export const safeLocalStorageGet = key => {
  if (!hasLocalStorage() || !key) return null;
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

export const safeLocalStorageSet = (key, value) => {
  if (!hasLocalStorage() || !key) return false;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (e) {
    return false;
  }
};

export const safeLocalStorageRemove = key => {
  if (!hasLocalStorage() || !key) return false;
  try {
    window.localStorage.removeItem(key);
    return true;
  } catch (e) {
    return false;
  }
};

